import { useSelector } from 'react-redux'
import { Button } from 'shared/components/Button/Button'
import { TaskStatusEnum } from 'shared/components/TaskList/TaskList'
import { useLMSLoginUrl } from 'shared/hooks/query/useLMSLoginUrl'
import { OnboardingChecklist, OnboardingSubChecklist } from 'shared/models/onboarding'

import { useHasLMSMigrationFlag } from 'hooks/useHasFeatureFlag'
import { currentUserSelector } from 'redux/selectors/users'

interface OnboardingWebinarButtonProps {
  task: OnboardingChecklist | OnboardingSubChecklist
}

function renderText(task: OnboardingChecklist | OnboardingSubChecklist) {
  if (task.status === TaskStatusEnum.NOT_STARTED) {
    return 'Start'
  } else {
    return 'Continue'
  }
}

export function OnboardingWebinarButton(props: OnboardingWebinarButtonProps) {
  const userId = useSelector(currentUserSelector).id
  const hasLMSMigrationFlag = useHasLMSMigrationFlag()

  const { lmsLoginUrl, isLoading, isFetching, refetch } = useLMSLoginUrl(userId, {
    enabled: hasLMSMigrationFlag,
  })
  const loginUrl = hasLMSMigrationFlag ? lmsLoginUrl : props.task.context?.sentix_login_url

  // We will assume that the LMS login URL has been used when the user clicks the button, so we need to refetch the URL, since it can only be used once.
  const handleClick = () => {
    if (hasLMSMigrationFlag) {
      refetch()
    }
  }

  return (
    <Button
      size="medium"
      variant="secondary"
      href={loginUrl}
      target="_blank"
      isLoading={hasLMSMigrationFlag ? isLoading || isFetching : false}
      onClick={handleClick}
    >
      {renderText(props.task)}
    </Button>
  )
}
